import { useState } from "react";

const faqs = [
  { q: "What is MiiQ FitFinder?", a: "MiiQ FitFinder is a premium personality and career assessment app that helps you discover your Team Fit, Company Fit, and Career Fit using a series of psychologically-informed questions." },
  { q: "How do I reset or retake my assessment?", a: "You can retake the assessment at any time by logging out and starting a new session, or by contacting us at support@miiqfitfinder.com." },
  { q: "How do I cancel my subscription?", a: "iOS: Settings > Apple ID > Subscriptions > MiiQ FitFinder > Cancel. Android: Google Play > Subscriptions > MiiQ FitFinder > Cancel." },
  { q: "I was charged but cannot access premium features. What do I do?", a: "Try restoring purchases in-app (Settings > Restore Purchases). If it persists, email support@miiqfitfinder.com with your account email and transaction ID." },
  { q: "Is my data private?", a: "Yes. Your assessment data is stored securely and never sold to third parties. See our Privacy Policy for full details." },
  { q: "The app crashed or is not loading. What should I do?", a: "Force-close and reopen the app. If it continues, uninstall and reinstall. Your data is saved to the cloud. Email support@miiqfitfinder.com with your device and OS version if issues persist." },
];

const SUPPORT_EMAIL = "support@miiqfitfinder.com";

export default function Support() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);
  return (
    <div style={styles.page}>
      <div style={styles.blob1} /><div style={styles.blob2} />
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.logoRow}><img src="/logo.png" alt="MiiQ FitFinder" style={{height:64,borderRadius:12}}/></div>
          <h1 style={styles.h1}>How can we <em style={{color:"#D4AF37"}}>help?</em></h1>
          <p style={styles.subtitle}>Support for MiiQ FitFinder - your career and personality assessment companion.</p>
        </header>
        <div style={styles.sectionLabel}><span>Contact Us</span><div style={styles.sectionLine}/></div>
        <div style={styles.contactCard}>
          <div style={styles.contactIcon}>Email</div>
          <div style={{flex:1}}>
            <h3 style={styles.contactTitle}>Email Support</h3>
            <p style={styles.contactSub}>Our team typically responds within 1-2 business days.</p>
            <a href={"mailto:"+SUPPORT_EMAIL} style={styles.emailLink}>{SUPPORT_EMAIL}</a>
          </div>
          <div style={styles.badge}>1-2 Business Days</div>
        </div>
        <div style={{marginBottom:56}}>
          <div style={styles.sectionLabel}><span>FAQ</span><div style={styles.sectionLine}/></div>
          <h2 style={styles.h2}>Common Questions</h2>
          {faqs.map((faq,i) => (
            <div key={i} style={styles.faqItem}>
              <button style={styles.faqQ} onClick={()=>toggle(i)}>
                <span>{faq.q}</span>
                <span style={{...styles.chevron,transform:openIndex===i?"rotate(180deg)":"rotate(0deg)",background:openIndex===i?"rgba(212,175,55,0.1)":"transparent"}}>v</span>
              </button>
              {openIndex===i && <p style={styles.faqA}>{faq.a}</p>}
            </div>
          ))}
        </div>
        <div style={{marginBottom:56}}>
          <div style={styles.sectionLabel}><span>Legal</span><div style={styles.sectionLine}/></div>
          <h2 style={styles.h2}>Policies</h2>
          <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
            <a href="/privacy" style={styles.legalLink}>Privacy Policy</a>
            <a href="/terms" style={styles.legalLink}>Terms of Service</a>
          </div>
        </div>
        <div style={styles.sectionLabel}><span>About</span><div style={styles.sectionLine}/></div>
        <div style={styles.aboutCard}>
          <p style={styles.aboutText}><strong style={{color:"#F9F7F2"}}>MiiQ FitFinder</strong> is developed by <strong style={{color:"#F9F7F2"}}>Taradome Entertainment Group LLC</strong>.</p>
          <p style={styles.aboutText}>Web: <a href="https://miiq-fitfinder.vercel.app" style={styles.goldLink}>miiq-fitfinder.vercel.app</a></p>
          <p style={styles.aboutText}>Contact: <a href={"mailto:"+SUPPORT_EMAIL} style={styles.goldLink}>{SUPPORT_EMAIL}</a></p>
        </div>
        <footer style={styles.footer}>
          <p style={styles.footerText}>2026 Taradome Entertainment Group LLC. All rights reserved.</p>
          <a href={"mailto:"+SUPPORT_EMAIL} style={styles.footerLink}>{SUPPORT_EMAIL}</a>
        </footer>
      </div>
    </div>
  );
}

const styles = {
  page:{background:"#2E1A47",minHeight:"100vh",color:"#F9F7F2",fontFamily:"sans-serif",fontWeight:300,overflowX:"hidden",position:"relative"},
  blob1:{position:"fixed",inset:0,background:"radial-gradient(ellipse 80% 50% at 20% 10%,rgba(212,175,55,0.08) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  blob2:{position:"fixed",inset:0,background:"radial-gradient(ellipse 60% 80% at 80% 90%,rgba(75,54,99,0.4) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  container:{maxWidth:760,margin:"0 auto",padding:"0 24px",position:"relative",zIndex:1},
  header:{padding:"48px 0 40px",borderBottom:"1px solid rgba(212,175,55,0.2)",marginBottom:56},
  logoRow:{display:"flex",alignItems:"center",gap:14,marginBottom:32},
  logoIcon:{width:40,height:40,background:"linear-gradient(135deg,#D4AF37,#B8860B)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,color:"#2E1A47",flexShrink:0},
  logoText:{fontSize:22,fontWeight:600,letterSpacing:"0.04em",color:"#F9F7F2"},
  h1:{fontSize:42,fontWeight:700,lineHeight:1.1,color:"#F9F7F2",marginBottom:12},
  subtitle:{fontSize:15,color:"#9A8C9D",lineHeight:1.6,maxWidth:480},
  contactCard:{background:"rgba(61,38,90,0.5)",border:"1px solid rgba(212,175,55,0.25)",borderRadius:16,padding:32,marginBottom:48,display:"flex",alignItems:"center",gap:24,flexWrap:"wrap"},
  contactIcon:{width:52,height:52,background:"rgba(212,175,55,0.1)",border:"1px solid rgba(212,175,55,0.3)",borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#D4AF37",flexShrink:0},
  contactTitle:{fontSize:20,fontWeight:600,color:"#F9F7F2",marginBottom:4},
  contactSub:{fontSize:14,color:"#9A8C9D",marginBottom:8},
  emailLink:{color:"#D4AF37",textDecoration:"none",fontSize:15,fontWeight:500},
  badge:{marginLeft:"auto",background:"rgba(212,175,55,0.1)",border:"1px solid rgba(212,175,55,0.2)",borderRadius:20,padding:"6px 14px",fontSize:12,color:"#D4AF37",textTransform:"uppercase",whiteSpace:"nowrap"},
  sectionLabel:{fontSize:11,letterSpacing:"0.12em",textTransform:"uppercase",color:"#D4AF37",marginBottom:20,display:"flex",alignItems:"center",gap:10},
  sectionLine:{flex:1,height:1,background:"rgba(212,175,55,0.2)"},
  h2:{fontSize:28,fontWeight:600,color:"#F9F7F2",marginBottom:24},
  faqItem:{borderBottom:"1px solid rgba(255,255,255,0.07)"},
  faqQ:{width:"100%",background:"none",border:"none",cursor:"pointer",padding:"20px 0",display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,textAlign:"left",fontSize:15,fontWeight:500,color:"#F9F7F2"},
  chevron:{width:20,height:20,border:"1px solid rgba(212,175,55,0.3)",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"transform 0.3s",fontSize:12,color:"#D4AF37",padding:"0 4px"},
  faqA:{fontSize:14,color:"#9A8C9D",lineHeight:1.7,paddingBottom:20,margin:0},
  legalLink:{display:"inline-flex",alignItems:"center",gap:8,padding:"12px 20px",background:"rgba(61,38,90,0.4)",border:"1px solid rgba(212,175,55,0.2)",borderRadius:10,color:"#F9F7F2",textDecoration:"none",fontSize:14},
  aboutCard:{background:"rgba(61,38,90,0.3)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:16,padding:32,marginBottom:56},
  aboutText:{fontSize:14,color:"#9A8C9D",lineHeight:1.8,marginBottom:8},
  goldLink:{color:"#D4AF37",textDecoration:"none"},
  footer:{borderTop:"1px solid rgba(212,175,55,0.15)",padding:"32px 0 40px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12},
  footerText:{fontSize:12,color:"rgba(154,140,157,0.6)"},
  footerLink:{color:"rgba(212,175,55,0.6)",textDecoration:"none",fontSize:12},
};
